module.exports = __webpack_public_path__ + "img/B969.cbf4671e.jpg";